<template>
  <svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0.916016 0.416626L4.92643 4.99996L0.916016 9.58329" stroke="#828282"/>
  </svg>
</template>

<script>
export default {
  name: "IconRight"
}
</script>
